import {MESSAGE_TYPE} from "../context/actionTypes";
import PDFIcon from "../utils/icons/file_types/pdf.svg";


export enum MessageState {
    PROCESSED = "processed",
    ERROR = "error",
    PROCESSING = "processing",
}

export interface RagOutput {
    source_id: number;
    source: string;
    source_type: string;
    page: number;
    distance: number;
    chunk: string;
}

export interface ChatMessage {
    type: MESSAGE_TYPE;
    message: string;
    date?: string;
    state?: MessageState;
    rag?: RagOutput[];
}

export function assumeProcessedState(message: ChatMessage) {
    return message.state === undefined || message.state === MessageState.PROCESSED;
}

export const fileIcons: Record<string, string> = {
    pdf: PDFIcon,
};